import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Card from "shared/Card";
import styles from "./index.module.css";

/**
 * Per-section collapse/expand affordance used across the Product Editor.
 * Every editor section is wrapped in this component so the user can collapse
 * sections they aren't editing. Figma shows a `Collapse` / `Expand` link on
 * each section header.
 */
export default function CollapsibleSection({
  title,
  defaultCollapsed,
  headerAccessory,
  className,
  bodyClassName,
  children,
}) {
  const [collapsed, setCollapsed] = useState(Boolean(defaultCollapsed));

  return (
    <Card className={classNames(styles.section, className)}>
      <div
        className={classNames(styles.header, {
          [styles.headerCollapsed]: collapsed,
        })}
      >
        <span className={styles.title}>{title}</span>
        <div className={styles.headerRight}>
          {headerAccessory}
          <button
            type="button"
            className={styles.toggle}
            aria-expanded={!collapsed}
            onClick={() => setCollapsed((prev) => !prev)}
            title={collapsed ? "Expand this section" : "Collapse this section"}
          >
            {collapsed ? "Expand" : "Collapse"}
          </button>
        </div>
      </div>
      {!collapsed && (
        <div className={classNames(styles.body, bodyClassName)}>{children}</div>
      )}
    </Card>
  );
}

CollapsibleSection.propTypes = {
  title: PropTypes.node.isRequired,
  defaultCollapsed: PropTypes.bool,
  headerAccessory: PropTypes.node,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  children: PropTypes.node,
};

CollapsibleSection.defaultProps = {
  defaultCollapsed: false,
  headerAccessory: null,
  className: "",
  bodyClassName: "",
  children: null,
};
